module.exports = [
    {
        minLevel: 10,
        maxLevel: 24,
        name: '福特野马',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/9a18f2d71eee393539080d3474c35f3f.png'
    },
    {
        minLevel: 25,
        maxLevel: 34,
        name: '宝马M3',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/24272a53567e36e87ca53490b5620bd8.png',
    },
    {
        minLevel: 35,
        maxLevel: 49,
        name: '玛莎拉蒂GranTurismo',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/c86e2e851c206c909cb8406668fe61bf.png'
    },
    {
        minLevel: 50,
        maxLevel: 59,
        name: '阿斯顿·马丁DB9',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/ddb56fb73d0f3dcf49bbcbacd32a2e58.png'
    },
    {
        minLevel: 60,
        maxLevel: 69,
        name: '兰博基尼Huracan',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/73d8cd4a3b06342788767c8d3ed3a581.png'
    },
    {
        minLevel: 70,
        maxLevel: 79,
        name: '宾利慕尚',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/1bb0e4a756717315cbe495015184108e.png'
    },
    {
        minLevel: 80,
        maxLevel: 89,
        name: '劳斯莱斯幻影',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/b0c84a5c817b8cb3cf5064fbcf9b7300.png'
    },
    {
        minLevel: 90,
        maxLevel: 99,
        name: '布加迪威航',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/d265fc617c45186b0446388df26e29e8.png'
    },
    {
        minLevel: 100,
        maxLevel: 109,
        name: 'W Motors莱肯',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/fa53fe57763bfa495c88f41e4aa72bb7.png'
    },
    {
        minLevel: 110,
        maxLevel: 119,
        name: '法拉帝960',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/babfc5297e0e3cbc180d2ac1ff3951da.png'
    },
    {
        minLevel: 120,
        maxLevel: 129,
        name: '圣汐115 Sport Yacht',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/0237f9532cb8cbfea9f380e89396a20a.png'
    },
    {
        minLevel: 130,
        maxLevel: 139,
        name: '圣劳伦佐SL118',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/ec2e24250b8a973f0bc8e12049dc2c7b.png'
    },
    {
        minLevel: 140,
        maxLevel: 149,
        name: '圣劳伦佐SD126',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/8b4d673a11b6df07aae447d652c76fba.png'
    },
    {
        minLevel: 150,
        maxLevel: 159,
        name: '圣汐131Yacht',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/b929a6a2efc88ba031480e02c081a439.png'
    },
    {
        minLevel: 160,
        maxLevel: 169,
        name: '达索Falcon900',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/53831d65a481303497109215119ce0ec.png'
    },
    {
        minLevel: 170,
        maxLevel: 179,
        name: '湾流G55',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/6a71b0677d6d459b5897692f18e89b65.png'
    },
    {
        minLevel: 180,
        maxLevel: 189,
        name: '庞巴迪全球快车',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/62e5afe301016ad34e437812f0a478e3.png'
    },
    {
        minLevel: 190,
        maxLevel: 199,
        name: '波音 787',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/2bab11825adde6e58ad7cd0711a82898.png'
    },
    {
        minLevel: 200,
        maxLevel: 200,
        name: '空中客车 A380',
        pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/dbe215e1947e65d36606eaa40388c37a.png'
    }
];


// WEBPACK FOOTER //
// ./js/living/message/levels.js